import { Tabs } from "./types";

export const CLOSURE_INFLUENCER_TABS: {
  value: Tabs;
  label: string;
  description: string;
  empty: string;
}[] = [
  {
    value: Tabs.All,
    label: "All",
    description: "All Purchased creators on this project.",
    empty: "No Purchased creators on this project yet.",
  },
  {
    value: Tabs.ConfirmationPending,
    label: "Confirmation pending",
    description: "Creators awaiting purchase confirmation mail.",
    empty: "No creators awaiting confirmation mail.",
  },
  {
    value: Tabs.ConfirmationSent,
    label: "Confirmation mail sent",
    description:
      "Confirmation recorded; creator may still need final confirmation.",
    empty: "No creators with confirmation mail sent yet.",
  },
  {
    value: Tabs.Confirmed,
    label: "Confirmed",
    description: "Purchase confirmation completed for these creators.",
    empty: "No confirmed creators on this project yet.",
  },
];
